var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 40,
        "min-height": 60,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v("Override Business hours")]),
          ]
        ),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("override-business-hours", {
            ref: "overrideBusinessHours",
            attrs: {
              "override-business-hours-id": _vm.overrideBusinessHoursId,
              "enable-save": _vm.enableSave,
              "is-new": _vm.isNew,
            },
            on: { save: _vm.handleSave },
          }),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot is-flex is-justify-content-flex-end" },
        [
          _c("div", { staticClass: "buttons" }, [
            _vm.enableSave
              ? _c(
                  "button",
                  {
                    staticClass: "button is-success tooltip",
                    attrs: { "data-tooltip": _vm.isNew ? "Add" : "Save" },
                    on: { click: _vm.save },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "mdi mdi-content-save mdi-20px" }),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.isNew ? "Add" : "Save"))]),
                  ]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "button tooltip",
                attrs: { "data-tooltip": "Close" },
                on: { click: _vm.close },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-close mdi-20px" }),
                ]),
                _c("span", [_vm._v("Close")]),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }